import { render, staticRenderFns } from "./BookSection.vue?vue&type=template&id=19954586&"
import script from "./BookSection.vue?vue&type=script&lang=js&"
export * from "./BookSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports